import createLucideIcon from '../createLucideIcon';

const ArrowRightFromLine = createLucideIcon('ArrowRightFromLine', [
  ['line', { x1: '21', x2: '7', y1: '12', y2: '12', key: '1vpj1h' }],
  ['polyline', { points: '15 18 21 12 15 6', key: '1elp5v' }],
  ['path', { d: 'M3 5v14', key: '1nt18q' }],
]);

export default ArrowRightFromLine;
